import { render } from "./CaseStatusYearWise.vue?vue&type=template&id=64f1754f&scoped=true"
import script from "./CaseStatusYearWise.vue?vue&type=script&lang=js"
export * from "./CaseStatusYearWise.vue?vue&type=script&lang=js"

import "./CaseStatusYearWise.vue?vue&type=style&index=0&id=64f1754f&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-64f1754f"]])

export default __exports__